import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-grid p-px-4 p-py-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-12" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "p-component view-title" }, "DEXPRO Plattform")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "p-col-12 p-md-6 p-lg-4 p-xl-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.showDevDisclaimer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_Panel, {
              header: _ctx.$t('Platform.Guide.WelcomeCard.Title')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Platform.Guide.WelcomeCard.Text")) + " ", 1),
                _createVNode(_component_Message, { severity: "warn" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("Platform.Guide.WelcomeCard.Disclaimer")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["header"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}